import React, { useRef } from 'react';

import EnhancedModal from '../../common/EnhancedModal/EnhancedModal';
import { checkIfDisabled } from '../../../utils/shipping-utils';
import ShipFreeProductVariantSelectionCard from './ShipFreeProductVariantSelectionCard';
import styles from './variantSelectionModal.module.css';
import ModalCommonButtonsContainer from '../../common/ModalComponent/ModalCommonButtonsContainer';
import { useScrollShadow } from '../../../hooks/useScrollShadow';
import useIsMobile from '../../../hooks/useIsMobile';

function VaraintSelectionModal({
  show,
  onClose,
  quantities,
  setQuantities,
  selectedProducts,
  removeProduct,
  allOptions,
  setAllOptions,
  setSelectedProducts,
  onSave,
  quantityLabel = 'Quantity',
  disableQuantitySelection = false,
  defaultCurrency,
  handleBack,
}: any) {
  const scrollColumnRef = useRef(null);
  const isScrollShadow = useScrollShadow(scrollColumnRef);
  const isMobile = useIsMobile();
  // clone variant
  const cloneObject = (index: number) => {
    if (index < 0 || index >= selectedProducts.length || selectedProducts.length >= 3) return;
    const id = Date.now().toString();
    const newArray = selectedProducts.map((obj: any) => ({ ...obj }));
    const clonedObject = { ...newArray[index], id };
    newArray.splice(index + 1, 0, clonedObject);
    setSelectedProducts(newArray);
    setQuantities({ ...quantities, [id]: 1 });
  };

  return (
    <div>
      <EnhancedModal
        open={show}
        onClose={onClose}
        showBackButton
        handleBack={handleBack}
        width={637}
        maxWidth={637}
        maxHeight={699}
        bodyClassName="p-0"
        footerClassName={`p-0 ${(selectedProducts.length > 1 || isScrollShadow) && 'upper-shadow'}`}
        title="Select Variants"
        subtitle={!isMobile ? 'Please select the variants to request products' : undefined}
        headerClassName={isScrollShadow ? 'shadow-down' : ''}
        footer={
          <ModalCommonButtonsContainer
            submitButtonText={
              <span className={isMobile ? 'text-sm' : 'text-base'}>Add ({selectedProducts.length}) Products</span>
            }
            cancelButtonText={<span className={isMobile ? 'text-sm' : 'text-base'}>Go Back</span>}
            onClose={handleBack}
            onSave={() => {
              onSave();
            }}
            className={`${isMobile ? 'p-4 flex flex-col-reverse' : 'p-6'}`}
            disabled={checkIfDisabled(selectedProducts, allOptions)}
          />
        }
      >
        <div className={styles.variantSelectionModalShipFreeFlow}>
          <div className={styles.shipFreeProductVariantsContainerWrapper} ref={scrollColumnRef}>
            <div className={styles.shipFreeProductVariantsContainer}>
              {selectedProducts?.length > 0 &&
                selectedProducts?.map((product: any, index: number) => {
                  return (
                    <ShipFreeProductVariantSelectionCard
                      key={product.id}
                      {...product}
                      removeProduct={removeProduct}
                      quantities={quantities}
                      setQuantities={setQuantities}
                      allOptions={allOptions}
                      setAllOptions={setAllOptions}
                      cloneObject={cloneObject}
                      productIndex={index}
                      hideBorder={index === selectedProducts.length - 1}
                      cloneTooltip={selectedProducts.length === 3 ? 'Max Product Limit Reached' : 'Add new variant'}
                      cloneIconColor={selectedProducts.length === 3 ? 'var(--purple-p-200)' : 'var(--icon-highlight)'}
                      cloneTooltipPlacement="bottom"
                      quantityLabel={quantityLabel}
                      disableQuantitySelection={disableQuantitySelection}
                      defaultCurrency={defaultCurrency}
                      removeCloneIcon
                    />
                  );
                })}
            </div>
          </div>
        </div>
      </EnhancedModal>
    </div>
  );
}

export default VaraintSelectionModal;
